import { Setup } from "appworks/boot/setup";
import { Components } from "appworks/components/components";
import { gameLoop } from "appworks/core/game-loop";
import { animationManager } from "appworks/graphics/animation/animation-manager";
import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { graphicsManager } from "appworks/graphics/graphics-manager";
import { Layers } from "appworks/graphics/layers/layers";
import { particleManager } from "appworks/graphics/particles/particle-manager";
import { spineManager } from "appworks/graphics/spine/spine-manager";
import { gameState } from "appworks/model/game-state";
import { builderManager } from "appworks/server/builders/builder-manager";
import { Services } from "appworks/services/services";
import { StandardI18nAliases } from "appworks/services/translations/standard-i18n-aliases";
import { stateMachine } from "appworks/state-machine/state-machine";
import { uiFlags } from "appworks/ui/flags/ui-flags";
import { UI } from "appworks/ui/ui";
import { deviceInfo } from "appworks/utils/device-info";
import { logger } from "appworks/utils/logger";
import { Timer } from "appworks/utils/timer";
import { Easing } from "appworks/utils/tween";
import { gameLayers } from "game-layers";
import { ReelSpinner } from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import { DebugMenu } from "slotworks/debug/menu/debug-menu";
import { slotDefinition } from "slotworks/model/slot-definition";
import { slotModel } from "slotworks/model/slot-model";
import { EmptySetup } from "./empty-setup";

declare var window: any;

//////////////////////////////////////////////////////////////////////////////
/////////////////////
//////////

export abstract class BaseSetup extends EmptySetup {

    public setupDebug(): void {
        DebugMenu.init();

        window.Services = Services;
        window.Layers = Layers;
        window.Components = Components;
        window.Timer = Timer;
        window.UI = UI;
        window.ReelSpinner = ReelSpinner;
        window.Easing = Easing;
        window.stateMachine = stateMachine;
        window.gameState = gameState;
        window.uiFlags = uiFlags;
        window.builderManager = builderManager;
        window.canvasManager = canvasManager;
        window.deviceInfo = deviceInfo;
        window.graphicsManager = graphicsManager;
        window.spineManager = spineManager;
        window.gameLayers = gameLayers;
        window.slotModel = slotModel;
        window.animationMangaer = animationManager;
        window.deviceInfo = deviceInfo;
        window.slotDefinition = slotDefinition;
        window.particleManager = particleManager;
    }

    public setupCanvas(): void {
        deviceInfo.selectLayout({
            phone: "mobile",
            tablet: "mobile",
            desktop: "desktop"
        });

        canvasManager.fullScreenEnabled = true;
        canvasManager.setPortraitCanvasEnabled(true);
    }

    public setupI18N(): void {
        StandardI18nAliases();
    }
}
